"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("../../../core");
var component_1 = require("../../component");
// <RouteList> ... </RouteList>
var RouteList = /** @class */ (function (_super) {
    __extends(RouteList, _super);
    function RouteList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.match = function () {
            // subsequent match & enter/leave on routes
            if (!_this.childComponents)
                return;
            for (var _i = 0, _a = _this.childComponents; _i < _a.length; _i++) {
                var route = _a[_i];
                route.match();
            }
        };
        _this.cacheGroupChange = function () {
            // subsequent match & enter/leave on routes
            if (!_this.childComponents)
                return;
            for (var _i = 0, _a = _this.childComponents; _i < _a.length; _i++) {
                var route = _a[_i];
                route.cacheGroupFn();
            }
        };
        return _this;
    }
    RouteList.prototype.onAfterRender = function () {
        core_1.st.router.addOnLocationChangeHandler(this.match);
        core_1.st.router.addOnAfterCacheGroupChangeHandler(this.cacheGroupChange);
        this.match();
        this.cacheGroupChange();
    };
    RouteList.prototype.render = function () {
        return this.renderChildren();
    };
    RouteList.prototype.onDisconnect = function () {
        core_1.st.router.removeOnLocationChangeHandler(this.match);
        core_1.st.router.removeOnAfterCacheGroupChangeHandler(this.cacheGroupChange);
    };
    RouteList = __decorate([
        component_1.component
    ], RouteList);
    return RouteList;
}(core_1.st.component));
exports.RouteList = RouteList;
//# sourceMappingURL=route-list.js.map